import LTR from "@brand-icons/ploom/chevron-down/chevron-down-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ChevronDownIcon = iconFactory("ChevronDownIcon", LTR);
